import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tKgpco/Store/CustomHandlerCreator";
import CustomOrderHistoryState from "@tKgpco/Store/Data/OrderHistory/OrderHistoryStateExtension";

type HandlerType = CustomHandler<CustomOrderHistoryState>;

export const DispatchClearOrderHistoryFilter: HandlerType = props => {
    props.dispatch({
        type: "Custom/OrderHistory/ClearFilters",
        clearOrderHistoryFilters: props.parameter.clearOrderHistoryFilters,
        getOrderHistoryParams: props.parameter.getOrderHistoryParams,
    });
};

export const chain = [DispatchClearOrderHistoryFilter];

const customClearOrderHistoryFilter = createHandlerChainRunner(chain, "CustomClearOrderHistoryFilter");
export default customClearOrderHistoryFilter;
